import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useShortHaulsList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'check', sortable: false },
        { key: 'tfNumber', label: 'TF Number', sortable: true },
        { key: 'transporter', label: 'Transporter', sortable: true },
        { key: 'driver', label: 'Driver', sortable: true },
        { key: 'mobile', label: 'Mobile', sortable: true },
        { key: 'fleets', label: 'Truck', sortable: true },
        { key: 'source', label: 'Source', sortable: true },
        { key: 'destination', label: 'Destination', sortable: true },
        { key: 'sale', label: 'Sale #', sortable: false },
        {
            key: 'dispatchedBales', label: 'Dispatched Bales', sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'dispatchedMass', label: 'Dispatched Mass', sortable: true, thClass: 'text-right', tdClass: 'text-right',
        },
        { key: 'loading_date', label: 'Loading Date', sortable: true },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('tfNumber')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-short_haul/list', {
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                isShortHaul: 1,
            })
            .then(response => {
                const { transports, meta } = response.data

                meta.value = meta

                callback(transports)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(error => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching transports list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
    }
}
